module.exports = __webpack_public_path__ + "static/media/AddlayerBlack.30eb8155.svg";